// extracted by mini-css-extract-plugin
export default {"itemInactive":"dW71q","list":"P0vcS","listItem":"sKr12","arrow":"G8tH2","arrowRight":"p9EuH","arrowLeft":"oktFq"};